var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumanGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.506 7.988c0 4.089-3.212 7.403-7.176 7.403-3.963 0-7.176-3.314-7.176-7.403C6.154 3.9 9.367.586 13.33.586c3.964 0 7.176 3.314 7.176 7.402zM.772 24.964c0-4.088 3.213-7.402 7.176-7.402h10.764c3.963 0 7.176 3.314 7.176 7.402 0 4.089-3.213 7.403-7.176 7.403H7.948c-3.963 0-7.176-3.314-7.176-7.403z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanGray);
export default __webpack_public_path__ + "static/media/humanGray.428e3f7d3463f04b8a151b0bf81caa4b.svg";
export { ForwardRef as ReactComponent };